import React from 'react'
import Loading from '../../Container/Loading/Loading'
import ListItem from './CanidateListItem'
import _ from 'lodash'

const CanidateListItems = (props) => {
    const {listItems, myApplications, filterMyEvents, doToggleView } = props
    
    const checkIsMyEvent = (eventId) =>{
        const isMyEvent = myApplications.indexOf(eventId)
        if(isMyEvent===-1){
            return false
        } else {
            return true
        }
    }
    // if eventItemms = null (no events on fb available return Message)
    if(listItems===null) return <Loading text='Hilfebedarf wird geladen......' />
    if(_.values(listItems).length===0)return <div>Kein Hilfegesuch vorhanden</div>

    return (
        listItems.map(listItem => {
            return (filterMyEvents
                ? checkIsMyEvent(listItem.data.id)
                    ? <ListItem
                        key={listItem.data.id}
                        listItem={listItem}
                        doToggleView={doToggleView}
                        isMyEvent={checkIsMyEvent(listItem.data.id)}
    
                      />
                    : null
                : <ListItem
                    key={listItem.data.id}
                    listItem={listItem}
                    doToggleView={doToggleView}
                    isMyEvent={checkIsMyEvent(listItem.data.id)}
                    />
            )
        
        })
    )
}

export default CanidateListItems


// WEBPACK FOOTER //
// ./src/Components/Canidates/CanidateListItems.js